import React from 'react';
import { Section, Image, OnVisible } from 'components';
import * as styles from './styles.module.scss';

const AwardWinningBadges = (props) => {
  const { data } = props;
  const { primary, items } = data;

  const { title } = primary;

  // content checks
  const titleHtml = title?.html;

  return (
    <Section sliceName="AwardWinningBadges" className={styles.section} containerClassName={styles.container}>
      {titleHtml && <div dangerouslySetInnerHTML={{ __html: titleHtml }} className={styles.title} />}

      {items?.[0] && (
        <OnVisible visibleClassName={styles.logosVisible}>
          <ul className={styles.logos}>
            {items.map((item, index) => {
              if (!item?.logo?.url) return null;

              return (
                <li key={`award-winning-badge-${index}`} className={styles.logoContainer}>
                  <Image className={styles.logo} e image={item.logo} />
                </li>
              );
            })}
          </ul>
        </OnVisible>
      )}
    </Section>
  );
};

export default AwardWinningBadges;
